const FloatingLabelInput = ({ label, value, onChange, error, disabled, italic = false , type ="text"}) => {
  return (
    <div className="input-wrapper">
      <input
        type= {type}
        className={`input-field ${error ? 'error' : ''}`}
        value={value}
        onChange={onChange}
        placeholder=" "
        disabled={disabled}
        style={{ cursor: disabled ? 'default' : 'text', fontStyle: italic ? 'italic' : 'normal', fontSize: italic ? '14px' : '100%' }}
      />
      <label className="input-label">{label}</label>
    </div>
  );
};

export default FloatingLabelInput;